var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeNewImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.8,30h0c-3.7,0-6.8,3-6.8,6.8h0c0,3.7,3,6.8,6.8,6.8h0c3.7,0,6.8-3,6.8-6.8h0c0-3.7-3-6.8-6.8-6.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76,47.9v23.7c0,2.1-1.7,3.8-3.8,3.8H27.8c-.7,0-1.3-.2-1.9-.5l18.6-18.6,8.4,7.2c1.5,1.5,3.9,1.5,5.4,0l10-10c1.5-1.5,1.5-3.9,0-5.4h0c-1.5-1.5-3.9-1.5-5.4,0l-7.5,7.5-8.4-7.2c-1.5-1.5-3.9-1.5-5.4,0l-17.7,17.7V28.5c0-2.1,1.7-3.8,3.8-3.8h24.9c2.1,0,3.8-1.7,3.8-3.8h0c0-2.1-1.7-3.8-3.8-3.8h-24.9c-6.3,0-11.4,5.1-11.4,11.4v43.1c0,6.3,5.1,11.4,11.4,11.4h44.3c6.3,0,11.4-5.1,11.4-11.4v-23.7c0-2.1-1.7-3.8-3.8-3.8h0c-2.1,0-3.8,1.7-3.8,3.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.7,17.4c2.1,0,3.8,1.7,3.8,3.8v4.9h4.9c2.1,0,3.8,1.7,3.8,3.8s-1.7,3.8-3.8,3.8h-4.9v4.9c0,2.1-1.7,3.8-3.8,3.8s-3.8-1.7-3.8-3.8v-4.9h-4.9c-2.1,0-3.8-1.7-3.8-3.8s1.7-3.8,3.8-3.8h4.9v-4.9c0-2.1,1.7-3.8,3.8-3.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeNewImg);
export default __webpack_public_path__ + "static/media/acae_new_img.2475d683.svg";
export { ForwardRef as ReactComponent };